/**
 * Glob matcher for Custom Scripts `url_pattern` (Story 9.4, AC3).
 *
 * `matchUrlPattern(pattern, path)` decides whether a script whose author declared
 * `url_pattern` should run on the current router path.
 *
 * Normalization (applied to BOTH pattern and path):
 *  - drop the query string / hash;
 *  - strip a single leading `/app` segment — Chatwoot dashboard routes live under
 *    `/app` (router uses `createWebHistory()` with no base, and `frontendURL` builds
 *    `/app/...`), so `router.currentRoute.value.fullPath` INCLUDES `/app`. Normalizing
 *    it on both sides lets an author write the pattern with OR without `/app`;
 *  - normalize a single trailing slash (root `/` kept).
 *
 * Glob semantics: `*` compiles to `[^/]*` — a SINGLE path segment (never crosses `/`)
 * — and the whole pattern is fully anchored (`^…$`). Over-match is the dangerous
 * direction for injected scripts, so `*` is deliberately NOT `.*`; cross-segment
 * matching is a future explicit `**` opt-in. A blank/undefined pattern always matches.
 */

const normalize = value => {
  let v = String(value).split('?')[0].split('#')[0];
  if (v === '/app') v = '/';
  else if (v.startsWith('/app/')) v = v.slice(4);
  if (v.length > 1 && v.endsWith('/')) v = v.slice(0, -1);
  return v;
};

// Escapes every RegExp metachar. Applied to the literal chunks between `*` markers,
// which never contain `*` themselves (we split on it first).
const escapeRegex = chunk => chunk.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function matchUrlPattern(pattern, path) {
  if (
    pattern === undefined ||
    pattern === null ||
    String(pattern).trim() === ''
  ) {
    return true;
  }

  const body = normalize(pattern).split('*').map(escapeRegex).join('[^/]*');
  return new RegExp(`^${body}$`).test(normalize(path));
}
